const IntroductionDic = {
    'resumeTitle': {
        'fa': 'سوابق کاری و تحصیلات',
        'en': 'Comment'
    },
    'experience': {
        'fa': 'سوابق کاری',
        'en': 'Session'
    },
    'education': {
        'fa': 'تحصیلات',
        'en': 'Class'
    },
    'certificate': {
        'fa': 'مدارک',
        'en': 'certificate'
    },
    'teacher': {
        'fa': 'مدرس',
        'en': 'Teacher'
    },
    'student': {
        'fa': 'دانش آموز',
        'en': 'Student'
    },
    'intro': {
        'fa': 'معرفی',
        'en': 'Introduction'
    },
    'skill': {
        'fa': 'مهارت',
        'en': 'Skill'
    },
    'minPrice': {
        'fa': 'شروع قیمت از ساعتی',
        'en': 'Starting price from'
    },
    'location': {
        'fa': 'محل زندگی',
        'en': 'Location'
    }
    ,
    'tryOutClass': {
        'fa': 'کلاس آزمایشی',
    }
}
export default IntroductionDic